// extracted by mini-css-extract-plugin
export var centerText = "_d1-8";
export var container = "_d1-0";
export var doughnutContainer = "_d1-7";
export var legend = "_d1-a";
export var legendItemColorDisplay = "_d1-b";
export var legendItemLabel = "_d1-d";
export var legendItemValue = "_d1-c";
export var lg = "_d1-5";
export var maxWidth = "_d1-9";
export var md = "_d1-4";
export var responsive = "_d1-6";
export var sm = "_d1-3";
export var xs = "_d1-2";
export var xxs = "_d1-1";